module.exports = __webpack_public_path__ + "assets/06f78e715f562c8a13b6e014ff39ce9c.mp3";